import { cx } from '@mage-ui/styled-system/css';
import { sectionHeading, text, title } from '@mage-ui/styled-system/recipes';

export const SectionHeadingTitle = ({ data, ...props }) => {
  const classes = sectionHeading();
  return (
    <div className={classes.bottom} {...props}>
      {data.title && (
        <h2 className={cx(title({ size: '5', weight: 'bold' }), classes.title)}>
          {data.title}
        </h2>
      )}
      {data.intro && (
        <div
          className={cx(text({ size: '2', weight: 'medium' }), classes.intro)}
          dangerouslySetInnerHTML={{ __html: data.intro }}
        />
      )}
    </div>
  );
};
